function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import styled, { css } from 'styled-components';
import { fontStyle, spacing, themeLight } from '@naf/theme';
import { Error } from '@styled-icons/material/Error';
import { propValidationConfig } from '../propValidationConfig';
export const Message = ({
  children,
  className,
  error = false,
  disabled = false,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(MessageWrap, _extends({
    className: className
  }, rest, {
    error: error,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(Error, {
    size: 16
  })), children);
};
export default Message;
const MessageWrap = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "message__MessageWrap",
  componentId: "sc-1pjziy9-0"
})(["display:flex;align-items:center;margin-top:", ";", ";", " ", ""], spacing.space8, fontStyle.bodyText.small, ({
  error
}) => error && css(["color:", ";"], ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.error : themeLight.componentColors.alert.error), ({
  disabled
}) => disabled && css(["color:", ";"], ({
  theme
}) => theme.typography ? theme.typography.disabledText : themeLight.typography.disabledText));
const IconWrapper = styled.div.withConfig({
  displayName: "message__IconWrapper",
  componentId: "sc-1pjziy9-1"
})(["display:flex;svg{margin-right:", ";}"], spacing.space8);
//# sourceMappingURL=message.js.map